import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Question from "../../../../../assets/img/Help.png";
import Success from "../../../../../assets/img/Success.png";
import LoaderModal from "../../../../../components/LoaderModal/LoaderModal";
import Modal from "../../../../../components/Modal/Modal";
import { useUserState } from "../../../../../context/UserContext";
import { useAuthentication } from "../../../../hooks/useAuthentication";
import { formatDate } from "../../../../PojedinaObavijest/utils";
import AcceptanceModal from "../AcceptanceModal/AcceptanceModal";
import { acceptProgramApplication } from "../API/acceptProgramApplication";
import { postMentorReview } from "../API/postMentorComment";
import styles from "./OdobrenjeKomentar.module.css";
function OdobrenjeKomentar({
  onClose,
  firstName,
  lastName,
  userId,
  applicationId,
  mentorReview,
  course,
  fetchApplication,
  evidentionUserID,
  isReferadaAccepted,
  isMentorAccepted,
  mentorAcceptedAt,
  referadaAcceptedAt,
  acceptanceAuthor,
  acceptanceAuthorId,
  reviewAuthor,
}) {
  const { authToken } = useAuthentication();
  const { userData, role } = useUserState();
  const navigate = useNavigate();
  const [review, setReview] = useState(mentorReview || "");
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openAcceptanceModal, setOpenAcceptanceModal] = useState(false);
  const [isSuccesfullAcceptance, setIsSuccessfulAcceptance] =
    useState(isMentorAccepted);
  const [modalContent, setModalContent] = useState({
    image: "",
    description: "",
    buttons: [],
  });
  useEffect(() => {
    setReview(mentorReview || "");
    setIsSuccessfulAcceptance(isMentorAccepted);
    if (mentorReview !== undefined && isMentorAccepted !== undefined) {
      setIsLoading(false);
    }
  }, [mentorReview, isMentorAccepted]);
  let message;
  switch (course) {
    case "OR":
      message = "Osobni razvoj (OR)";
      break;
    case "eOR":
      message = "Osobni razvoj - hibrid (eOR)";
      break;
    case "TP1":
      message = "Terapeutski praktikum 1 (TP1)";
      break;
    case "TP2":
      message = "Terapeutski praktikum 2 (TP2)";
      break;
    case "TT":
      message = "Napredni terapeutski trening (TT)";
      break;
    default:
      message = "";
  }
  let notificationData = {
    primatelj: userId,
    subject: `Aplikacija za upis ${course}`,
    description: `Čestitamo na prijemu u program: ${message}`,
    userId: userData.id,
  };
  const handleApplicationResponse = (isAccepted) => {
    acceptProgramApplication(
      authToken,
      applicationId,
      setModalContent,
      Success,
      navigate,
      setShowModal,
      Question,
      setIsLoading,
      setOpenAcceptanceModal,
      fetchApplication,
      notificationData,
      isAccepted,
      role !== "Referada" ? `${userData?.firstName} ${userData?.lastName}` : "",
      role !== "Referada" ? userData?.id : null,
      role
    );
  };
  const mentorName =
    userData?.id !== acceptanceAuthorId ? acceptanceAuthor : "";
  const isMentor = course.includes("OR") ? "Mentor" : "Voditelj";
  return (
    <div>
      {isLoading && <LoaderModal />}
      <div
        className={styles.modalWrapper}
        style={{
          backgroundColor: evidentionUserID ? "#E7FDE7" : "#ffffff",
          borderRadius: !evidentionUserID && "16px",
          border:
            !evidentionUserID && role !== "Polaznik" && "1px solid #cb9c2d",
          marginTop: role === "Polaznik" ? "-40px" : "0px",
        }}
      >
        <div className={styles.infoModal}>
          {role !== "Polaznik" && (
            <p className={styles.title}>
              {`Evaluacija polaznika od strane ${isMentor.toLocaleLowerCase()}a za upis na ${course}`}
            </p>
          )}
          <p className={styles.subtitle}>
            {firstName && lastName && `Polaznik: ${firstName} ${lastName} `}
          </p>
          {role === "Referada" && !evidentionUserID && (
            <>
              {isMentorAccepted === null || isMentorAccepted === undefined ? (
                <p className={styles.subtitle} style={{ marginTop: "-10px" }}>
                  Trenutno nema evaluacije
                </p>
              ) : isMentorAccepted === true ? (
                <p className={styles.subtitle} style={{ marginTop: "-10px" }}>
                  Upis je odobrio/la {mentorName}
                  {mentorAcceptedAt
                    ? `(${
                        formatDate(mentorAcceptedAt).formattedDate
                      }   ${formatDate(mentorAcceptedAt).formattedTime}) `
                    : ""}
                </p>
              ) : isMentorAccepted === false ? (
                <p className={styles.subtitle} style={{ marginTop: "-10px" }}>
                  Upis nije odobrio/la {mentorName}
                  {mentorAcceptedAt
                    ? `(${
                        formatDate(mentorAcceptedAt).formattedDate
                      }  ${formatDate(mentorAcceptedAt).formattedTime}) `
                    : ""}
                </p>
              ) : (
                ""
              )}
            </>
          )}
          <div className={styles.inputWrapper}>
            {!evidentionUserID &&
              role !== "Polaznik" &&
              (() => {
                const isReferada = role === "Referada";
                const status = isReferada
                  ? isReferadaAccepted
                  : isSuccesfullAcceptance;
                const buttonClass = `${
                  styles[
                    status === false
                      ? "FalseBtn"
                      : status === true
                        ? "TrueBtn"
                        : "successBtn"
                  ]
                } ${isReferada ? styles.allowClick : ""}`;
                const buttonText =
                  status === false
                    ? `Odbijen upis na viši stupanj ${isReferada && referadaAcceptedAt ? `(${formatDate(referadaAcceptedAt).formattedDate} ${formatDate(referadaAcceptedAt).formattedTime})` : ""}`
                    : status === true
                      ? `Odobren upis na viši stupanj  ${isReferada && referadaAcceptedAt ? `(${formatDate(referadaAcceptedAt).formattedDate} ${formatDate(referadaAcceptedAt).formattedTime})` : ""}`
                      : `Primamo polaznika u viši stupanj ${course}`;
                return (
                  <button
                    className={buttonClass}
                    onClick={() => setOpenAcceptanceModal(true)}
                  >
                    {buttonText}
                  </button>
                );
              })()}
            <div className={styles.textareaWrapper}>
              {reviewAuthor && (
                <p
                  className={styles.subtitle}
                  style={{ marginTop: "-10px", marginBottom: "8px" }}
                >
                  Autor komentara:{" "}
                  {reviewAuthor ? reviewAuthor : "Nema podataka"}
                </p>
              )}
              <textarea
                placeholder={
                  !evidentionUserID &&
                  role !== "Referada" &&
                  role !== "Polaznik"
                    ? "Upiši svoj komentar"
                    : "Trenutno nema komentara"
                }
                className={styles.input}
                name="review"
                value={review}
                onChange={
                  !mentorReview ? (e) => setReview(e.target.value) : undefined
                }
                disabled={
                  Boolean(mentorReview) ||
                  evidentionUserID ||
                  role === "Referada" ||
                  role === "Polaznik"
                }
              />
            </div>
          </div>
          {!evidentionUserID &&
            !mentorReview &&
            role !== "Referada" &&
            role !== "Polaznik" && (
              <div className={styles.btnRow}>
                <button onClick={() => onClose()} className={styles.cancelBtn}>
                  Odustani
                </button>
                <button
                  className={styles.successBtn}
                  onClick={() =>
                    postMentorReview(
                      authToken,
                      userId,
                      applicationId,
                      review,
                      userData?.id,
                      `${userData?.firstName} ${userData?.lastName}`,
                      setModalContent,
                      Success,
                      setShowModal,
                      Question,
                      navigate,
                      fetchApplication,
                      isMentorAccepted,
                      setOpenAcceptanceModal
                    )
                  }
                >
                  Dodaj komentar
                </button>
              </div>
            )}
        </div>
      </div>
      {showModal && (
        <Modal
          image={modalContent.image}
          description={modalContent.description}
          buttons={modalContent.buttons}
        />
      )}
      {openAcceptanceModal && (
        <AcceptanceModal
          onAccept={() => handleApplicationResponse(true)}
          onClose={() => setOpenAcceptanceModal(false)}
          polaznik={`${firstName} ${lastName}`}
          role={role}
          program={course}
          fetchApplication={fetchApplication}
          onReject={() => handleApplicationResponse(false)}
          onUndecided={() => handleApplicationResponse(null)}
        />
      )}
    </div>
  );
}

export default OdobrenjeKomentar;
